var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllergies(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.059,
    height: 34.882,
    viewBox: "0 0 37.059 34.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(-541.978 -281.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M553.067,305.2c-3.429-4-3.915-8.24-1.543-12.857-1.474-1.332-2.946-2.686-4.457-4a1.064,1.064,0,0,0-.826-.018,3.256,3.256,0,1,1,2.163-2.464.941.941,0,0,0,.345,1.053c1.375,1.208,2.723,2.447,4.123,3.712a10.522,10.522,0,0,1,15.45.194c.814-.7,1.616-1.349,2.362-2.059.144-.137.12-.513.084-.765a3.256,3.256,0,1,1,5.736,1.452,3.144,3.144,0,0,1-3.513,1.033,1.049,1.049,0,0,0-1.259.266c-.669.624-1.382,1.2-2.125,1.84a10.663,10.663,0,0,1,.742,8.792c1,.561,1.993,1.143,3.016,1.664.149.076.469-.105.673-.229a3.255,3.255,0,1,1-1.489,2.926.991.991,0,0,0-.617-.99,12.431,12.431,0,0,0-2.136-1l-3.349,3.081c.354.637.853,1.59,1.42,2.5.1.164.489.2.747.21a3.26,3.26,0,0,1,3.234,2.921,3.215,3.215,0,0,1-2.555,3.52,3.241,3.241,0,0,1-3.495-4.758.95.95,0,0,0,0-1.107c-.5-.824-.945-1.676-1.445-2.573a10.712,10.712,0,0,1-9.7-1.079c-.358.425-.715.908-1.131,1.332q-1.95,1.99-3.942,3.938a.876.876,0,0,0-.263,1,3.245,3.245,0,0,1-6.232,1.809,3.173,3.173,0,0,1,2.126-4.018,8.327,8.327,0,0,1,1.985-.025c.217,0,.511.021.638-.1C549.584,308.685,551.318,306.944,553.067,305.2Zm15.719-7.435a8.273,8.273,0,1,0-8.245,8.308A8.257,8.257,0,0,0,568.787,297.764Zm5.916,7.8a1.078,1.078,0,1,0,1.117-1.077A1.092,1.092,0,0,0,574.7,305.567Zm-29.491-21.408a1.068,1.068,0,1,0,1.1,1.082A1.071,1.071,0,0,0,545.211,284.159Zm29.829,3.225a1.067,1.067,0,1,0-1.079,1.094A1.055,1.055,0,0,0,575.04,287.385Zm-27.78,26.248a1.059,1.059,0,0,0-1-1.1,1.067,1.067,0,0,0-.135,2.13A1.064,1.064,0,0,0,547.26,313.633Zm22.428-.835a1.069,1.069,0,1,0-1.027,1.085A1.084,1.084,0,0,0,569.688,312.8Z",
    transform: "translate(0 0)",
    fill: "#ee7404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M629.618,380.322a3.249,3.249,0,1,1,3.27,3.245A3.228,3.228,0,0,1,629.618,380.322Zm4.319.044a1.072,1.072,0,1,0-1.159,1.018A1.079,1.079,0,0,0,633.937,380.366Z",
    transform: "translate(-74.953 -81.33)",
    fill: "#ee7404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M691.907,404.444h-2.09v-2.082h2.09Z",
    transform: "translate(-126.438 -102.961)",
    fill: "#ee7404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M694.356,369.3v2.085h-2.1V369.3Z",
    transform: "translate(-128.523 -74.683)",
    fill: "#ee7404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M664.2,351.5h-2.089v-2.077H664.2Z",
    transform: "translate(-102.74 -57.685)",
    fill: "#ee7404"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergies);
export default __webpack_public_path__ + "static/media/allergies.197f9ad6ee478213ff056a2c46861800.svg";
export { ForwardRef as ReactComponent };